var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"cardBox",staticClass:"card-box",class:[
    { 'has-bg': _vm.backgroundColor || _vm.backgroundClass },
    _vm.backgroundColor ? '' : _vm.backgroundClass,
    _vm.layout,
    {'is-narrow': _vm.isNarrow}
  ],style:(_vm.backgroundColor ? `backgroundColor: ${_vm.backgroundColor}` : '')},[_c('ContentGeneratorElementsMedia',{attrs:{"value":_vm.content?.media,"aspect-ratio":_vm.aspectRatio,"aspect-ratio-mobile":_vm.aspectRatioMobile,"size-image":"w2000"}}),_vm._v(" "),_c('ContentGeneratorElementsText',{attrs:{"content":_vm.content?.text}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }